/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseAudioSettings
 */
export interface DatabaseAudioSettings {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAudioSettings
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAudioSettings
     */
    loop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAudioSettings
     */
    fileRef?: string;
}

/**
 * Check if a given object implements the DatabaseAudioSettings interface.
 */
export function instanceOfDatabaseAudioSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAudioSettingsFromJSON(json: any): DatabaseAudioSettings {
    return DatabaseAudioSettingsFromJSONTyped(json, false);
}

export function DatabaseAudioSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAudioSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'loop': !exists(json, 'loop') ? undefined : json['loop'],
        'fileRef': !exists(json, 'fileRef') ? undefined : json['fileRef'],
    };
}

export function DatabaseAudioSettingsToJSON(value?: DatabaseAudioSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'loop': value.loop,
        'fileRef': value.fileRef,
    };
}

